module.exports = __webpack_public_path__ + "img/bg-box.7f1c846a.png";